if (!customElements.get('quickshop-slider')) {
  class QuickshopSlider extends HTMLElement {
    constructor() {
      super();
      this.mainSlider = this.querySelector('[data-main-slider]');
      this.thumbsSlider = this.querySelector('[data-thumbs-slider]');
      this.mainSwiper = null;
      this.thumbsSwiper = null;
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      // Initialize thumbnail slider first
      this.thumbsSwiper = new Swiper(this.thumbsSlider, {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 10
          }
        }
      });

      // Initialize main slider
      this.mainSwiper = new Swiper(this.mainSlider, {
        spaceBetween: 10,
        allowTouchMove: false,
        enabled: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: this.thumbsSwiper
        },
        breakpoints: {
          768: {
            spaceBetween: 10,
            allowTouchMove: true,
            enabled: true
          }
        }
      });
    }

    disconnectedCallback() {
      if (this.mainSwiper) {
        this.mainSwiper.destroy();
      }
      if (this.thumbsSwiper) {
        this.thumbsSwiper.destroy();
      }
    }
  }

  customElements.define('quickshop-slider', QuickshopSlider);
}